var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('dean-dialog',{staticClass:"graph",attrs:{"title":"Mobile offers","icon":_vm.deanMobileIcon,"align-top":""}},[_c('div',{},[_c('line-chart',{attrs:{"data":_vm.source}})],1),(_vm.isLoading)?_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('dean-load-overlay')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }